import {CanDeactivate, Router} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<any>{

    constructor(private _router:Router){}

    canDeactivate(component: any ){
        return component.canDeactivate();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/unsaved-guard/unsaved-changes.guard.ts